/*
 * Projects data for the portfolio.
 * You can extend this file by adding new objects to the array.
 */

const projectsData = [
  {
    title: 'My Integral Future',
    description: 'Cast a holistic vision for your future and create a plan to make your 10/10 life a reality.',
    link: 'https://future.dalmo.ai',
    category: 'AI Tool',
    icon: 'images/integral-future.png',
    tags: ["integral", "ai", "design"]
  },
  {
    title: 'MOREchart',
    description: 'SMART on FHIR demo that turns a MyChart record into an action-oriented plan across 4 integral domains: Mind, Organism, Relationships, and Environment.',
    link: 'https://morechart.hiredalmo.com',
    category: 'Epic',
    icon: 'images/morechart.png',
    tags: ["healthcare", "integral", "ai", "design"]
  },
  {
    title: 'Claim Samaritan',
    description: 'Prototype healthcare platform simplifying insurance claims with a compassionate, user‑friendly interface.',
    link: 'https://claimsamaritan.com',
    category: 'AI Tool',
    icon: '',
    needsIcon: true,
    tags: ["healthcare", "ai", "design"]
  },
  {
    title: 'Nostra Luna di Miele',
    description: 'A responsive website showcasing memories from our 2025 Italian honeymoon.',
    link: 'https://nostralunadimiele.com/',
    category: 'Web',
    icon: 'images/nostra-luna.jpg',
    tags: ["design"]
  },
  {
    title: 'Integral Resources',
    description: 'Another portfolio dedicated to resources I\'ve created to explore Integral Theory.',
    link: 'https://integral.hiredalmo.com',
    category: 'Web',
    icon: 'images/integral.png',
    tags: ["integral", "design", "ai"]
  },
  {
    title: 'dalmo.ai',
    description: 'My personal landing spot on the internet: part cabinet of curiosities, part ministry notebook, part project arcade, part open door.',
    link: 'https://dalmo.ai',
    category: 'Web',
    icon: 'images/dalmo-ai.png',
    tags: ["design", "writing", "spiritual", "ai"]
  },
  {
    title: 'Dalmo & Viv',
    description: 'An archive of our ever-evolving love.',
    link: 'https://dalmoandviv.com',
    category: 'Web',
    icon: 'images/marriage.png',
    tags: ["design", "writing", "spiritual"]
  },
  {
    title: 'Questions to Fall in Love',
    description: 'Sets of 36 questions to inspire closeness, developed with my best friends and tested by my own love story.',
    link: 'https://love.dalmo.ai',
    category: 'Web',
    icon: 'images/connection-coaching.png',
    tags: ["design", "teaching", "spiritual"]
  },
  {
    title: 'Integral Marriage',
    description: 'A workshop and resource hub for helping couples build a thriving marriage informed by integral theory.',
    link: 'https://marriage.dalmo.ai',
    category: 'Teaching',
    icon: 'images/marriage.png',
    tags: ["integral", "teaching", "spiritual"]
  },
  {
    title: 'Oh, the Places You Went!',
    description: 'Transform your Google location history into an animated journey.',
    link: 'https://places.dalmo.ai/',
    category: 'Web',
    icon: 'images/places.png',
    tags: ["design"]
  },
  {
    title: 'Integral Bluesky Bots',
    description: 'A group of 7 bots, each with a totally different worldviewne, having conversations online around faith and the news.',
    link: 'https://bots.hiredalmo.com',
    category: 'AI Tool',
    icon: 'images/kenny.png',
    tags: ["integral", "ai"]
  },
  {
    title: 'Integral Chat',
    description: 'Seven AI personas representing developmental stages of Christian consciousness.',
    link: 'https://integralchat.com',
    category: 'AI Tool',
    icon: 'images/chatgpt.png',
    tags: ["integral", "ai", "spiritual"]
  },
  {
    title: 'Role Model Digest',
    description: 'Get a weekly smart summary of your role model\'s activity online, delivered to your inbox.',
    link: 'https://digest.dalmo.ai',
    category: 'AI Tool',
    icon: 'images/digest.png',
    tags: ["design", "ai"]
  },
  {
    title: 'One Prompt Web Apps',
    description: 'Collection of micro-projects built from a single natural-language prompt, showcasing rapid AI prototyping.',
    link: 'https://oneprompt.dalmo.ai/',
    category: 'Web',
    icon: 'images/ai.png',
    tags: ["design", "ai"]
  },
  {
    title: 'Code Room',
    description: 'A landing page for my AI-assisted music project.',
    link: 'https://coderoom.ai',
    category: 'AI Tool',
    icon: '../images/code-room.png',
    tags: ["design", "ai"]
  },
  {
    title: 'Evidently',
    description: 'AI-powered healthcare work focused on helping doctors surface the data they need at the speed of thought.',
    link: 'https://evidently.com',
    category: 'AI Tool',
    icon: 'images/healthcare-it.png',
    tags: ["healthcare", "ai"]
  },
  {
    title: 'The Creative Act: An AI Oracle',
    description: 'An AI bot that responds only in quotes from Rick Rubin\'s book.',
    link: 'https://thecreativeact.dalmo.ai/',
    category: 'AI Tool',
    icon: 'images/chatgpt.png',
    tags: ["ai", "writing", "art"]
  },
  {
    title: 'Teleport',
    description: 'Travel to a different AI-generated 360-degree location with every song.',
    link: 'https://teleport.dalmo.ai/',
    category: 'AI Tool',
    icon: 'images/teleport.png',
    needsIcon: true,
    tags: ["ai", "art", "design"]
  },
  {
    title: 'Integral Survival (Steam)',
    description: 'Indie game blending adventure and puzzle mechanics to explore stages of consciousness.',
    link: 'https://store.steampowered.com/app/4019910/Integral_Survival/',
    category: 'Game',
    icon: '../images/integral-survival.png',
    tags: ["games", "ai", "integral"]
  },
  {
    title: 'NVC Practice',
    description: 'Practice the nonviolent communication process using the OFNR model with AI-powered feedback.',
    link: 'https://nvc.dalmo.ai',
    category: 'AI Tool',
    icon: '../images/nvc.png',
    tags: ["design", "ai", "teaching"]
  },
  {
    title: "Compliance",
    description: 'A browser game based on the TV show Severance',
    link: 'https://lumonseverance.com',
    category: 'Game',
    icon: '../images/compliance.jpg',
    tags: ["games"]
  },
  {
    title: "Cappuccino’s Integral Climb",
    description: 'Browser-based platformer game teaching developmental stages through gameplay.',
    link: 'https://cappuccino.hiredalmo.com',
    category: 'Game',
    icon: 'images/integral-climb.png',
    tags: ["games", "integral"]
  },
  {
    title: "Dalmo Facts",
    description: 'How well do you know me? Let\'s play 2 Truths 1 Lie!',
    link: 'https://facts.dalmo.ai',
    category: 'Game',
    icon: 'images/facts.png',
    tags: ["design", "games"]
  },
  {
    title: "False Identities",
    description: 'Uncover and transform your false identity with this self-reflection exercise.',
    link: 'https://false.dalmo.ai',
    category: 'AI Tool',
    icon: 'images/false.png',
    tags: ["spiritual", "ai", "design"]
  },
  {
    title: "Meditate on the Word",
    description: 'Use rapid serial visual presentation to read scripture meditatively with no distractions.',
    link: 'https://lockin.dalmo.ai',
    category: 'Web',
    icon: 'images/lockin.png',
    tags: ["spiritual", "design"]
  },
  {
    title: 'Microchurch',
    description: 'A Sunday Midtown microchurch for prayer, worship, and studying scripture together.',
    link: 'https://citychurchtulsa.churchcenter.com/groups/microchurch/sunday-midtown-mendonca-microchurch',
    category: 'Ministry',
    icon: 'images/prayer-ministry.png',
    tags: ["spiritual", "teaching"]
  },
  {
    title: 'Kingdom Foundations',
    description: 'Frameworks for discipleship and the upside-down reign of Jesus.',
    link: 'https://kingdom.dalmo.ai',
    category: 'Ministry',
    icon: 'images/bible-teaching.png',
    tags: ["spiritual", "teaching", "writing"]
  },
  {
    title: 'Four Weeks With',
    description: 'Find a 4-week devotional tailored to how you connect with God.',
    link: 'https://fourweekswith.com',
    category: 'Ministry',
    icon: 'images/bible-teaching.png',
    tags: ["spiritual", "teaching", "writing"]
  },
  {
    title: "The Lord's Psalter",
    description: "Pray the psalms with original music, organized by the Lord's Prayer.",
    link: 'https://psalms.dalmo.ai',
    category: 'Music',
    icon: 'images/music-curation.png',
    tags: ["spiritual", "art", "writing"]
  },
  {
    title: 'Parables',
    description: 'Discover how different perspectives illuminate the same truth.',
    link: 'https://parables.dalmo.ai',
    category: 'Web',
    icon: 'images/bible-teaching.png',
    tags: ["spiritual", "teaching", "writing"]
  },
  {
    title: 'The Threshold',
    description: 'A reflection on humanity growing into who we were always meant to be.',
    link: 'https://threshold.dalmo.ai',
    category: 'Writing',
    icon: '',
    needsIcon: true,
    tags: ["spiritual", "writing", "integral"]
  },
  {
    title: 'Tulsa Homeless Resources',
    description: 'Free meals, shelter, healthcare, recovery, and support in Tulsa County.',
    link: 'https://resources.dalmo.ai',
    category: 'Resource',
    icon: 'images/outreach.png',
    tags: ["spiritual", "design"]
  },
  {
    title: 'Tulsa Prayer Map',
    description: 'A map-based invitation to pray for every neighborhood in Tulsa.',
    link: 'https://tulsaprayer.dalmo.ai',
    category: 'Ministry',
    icon: 'images/prayer-ministry.png',
    tags: ["spiritual", "design"]
  },
  {
    title: 'Timeline of Biblical Compositions',
    description: 'Explore the history of the making of the Bible.',
    link: 'https://timelines.dalmo.ai',
    category: 'Web',
    icon: 'images/bible-teaching.png',
    tags: ["spiritual", "teaching", "design"]
  },
  {
    title: 'Scripture in Layers',
    description: 'Visualize the composition of short biblical books.',
    link: 'https://layers.dalmo.ai',
    category: 'Web',
    icon: 'images/bible-teaching.png',
    tags: ["spiritual", "teaching", "design"]
  },
  {
    title: 'The Sower',
    description: 'A merged harmony of the parable of the sower across three gospel accounts.',
    link: 'https://sower.dalmo.ai',
    category: 'Web',
    icon: 'images/bible-teaching.png',
    tags: ["spiritual", "writing", "teaching"]
  },
  {
    title: "Landmarkle",
    description: 'Like wordle, but for landmarks with an AI twist',
    link: 'https://landmarkle.dalmo.ai',
    category: 'Game',
    icon: '',
    needsIcon: true,
    tags: ["games", "ai"]
  },
  {
    title: "Welcome to Roshar",
    description: 'An AI-assisted character builder for the Cosmere TTRPG.',
    link: 'https://welcometoroshar.com/',
    category: 'AI Tool',
    icon: '../images/roshar.png',
    tags: ["games", "ai", "language"]
  },
  {
    title: "LimeRhyme",
    description: 'Type Rhymes. Beat the Clock.',
    link: 'https://lime.hiredalmo.com/',
    category: 'Game',
    icon: '',
    needsIcon: true,
    tags: ["games", "ai", "language"]
  },
  {
    title: "Wordsworthy",
    description: 'Build a poem with AI.',
    link: 'https://wordsworthy.vercel.app/',
    category: 'Game',
    icon: 'images/wordsworthy.png',
    tags: ["games", "ai", "language"]
  },
  {
    title: 'Hats',
    description: 'The world looks a little different when you wear different hats.',
    link: 'https://hats.dalmo.ai',
    category: 'Game',
    icon: '',
    needsIcon: true,
    tags: ["games", "design"]
  },
  {
    title: 'Drifter',
    description: 'Explore a new world as a gem-hungry little alien.',
    link: 'https://drifter.dalmo.ai',
    category: 'Game',
    icon: '',
    needsIcon: true,
    tags: ["games", "design"]
  },
  {
    title: 'Guess the Guest',
    description: 'Ask questions to guess the mystery guest knocking at your door.',
    link: 'http://guest.dalmo.ai',
    category: 'Game',
    icon: '',
    needsIcon: true,
    tags: ["games", "ai", "design"]
  },
  {
    title: 'Scribble Dungeon',
    description: 'Work-in-progress browser game experiment.',
    link: 'https://dungeon.dalmo.ai',
    category: 'Game',
    icon: '',
    needsIcon: true,
    tags: ["games", "ai", "design"]
  },
  {
    title: 'Lantern Road',
    description: 'Work-in-progress browser game experiment.',
    link: 'https://lanternroad.dalmo.ai',
    category: 'Game',
    icon: '',
    needsIcon: true,
    tags: ["games", "design"]
  },
  {
    title: "Poets & Saints",
    description: 'A devotional arts magazine created with the City Arts Department.',
    link: 'https://hiredalmo.com/files/Poets&Saints-01-StreamsInTheDesert.pdf',
    category: 'Writing',
    icon: 'images/poets-and-saints.png',
    tags: ["spiritual", "writing", "ai", "language"]
  },
  {
    title: "Last Lament",
    description: 'A modern-day translation of the book of Lamentations.',
    link: 'https://lastlament.com',
    category: 'Writing',
    icon: 'images/last-lament.png',
    tags: ["language", "spiritual"]
  },
  {
    title: "Dalmo's World",
    description: 'Notes from my Substack.',
    link: 'https://dalmo.substack.com',
    category: 'Writing',
    icon: 'images/essays.png',
    tags: ["writing", "language"]
  },
  {
    title: 'Commonplacements',
    description: 'An interactive poetry-performance tool for communal attention and variable text.',
    link: 'https://commonplacements.com',
    category: 'Writing',
    icon: 'images/poetry-writing.png',
    tags: ["writing", "language", "art", "design"]
  },
  {
    title: 'Curbside Haikus 2026',
    description: 'A spring poetry project dedicated to adding beauty to Downtown Tulsa.',
    link: 'https://www.fox23.com/news/downtown-tulsa-blooms-with-poetry-as-2026-curbside-haikus-are-unveiled/article_79f6ec37-ba6c-49c7-aafd-c6e3ea7e8018.html',
    category: 'Writing',
    icon: 'images/poetry-writing.png',
    tags: ["writing", "language", "art"]
  },
  {
    title: 'Review My Draft',
    description: 'Get AI-powered feedback on your writing.',
    link: 'https://review.dalmo.ai/',
    category: 'AI Tool',
    icon: 'images/copy-editing.png',
    tags: ["ai", "writing", "language", "teaching"]
  },
  {
    title: 'Game Mechanic Playground',
    description: 'Browser-based sandbox for experimenting with AI‑generated game mechanics and immediate playtesting.',
    link: '',
    category: 'R&D',
    icon: 'images/-.png',
    tags: ["games", "ai"]
  },
  {
    title: 'Poetry',
    description: 'Some poems I like.',
    link: '',
    category: 'Writing',
    icon: '../images/poetry-writing.png',
    tags: ["writing", "language"],
    links: [
        {
            title: 'There was a frost',
            url: 'https://www.instagram.com/p/DCkVzrfS-b-'},
        {
            title: 'Last Lament',
            url: 'http://lastlament.com'},
        {
            title: 'Poets & Saints Magazine',
            url: '../files/Poets&Saints-01-StreamsInTheDesert.pdf'},
        {
            title: 'how to eat from gold plates',
            url: 'https://www.instagram.com/p/C2Rb8cCO0Mv/?img_index=1'},
        {
            title: 'Jump In',
            url: 'https://www.instagram.com/p/CymL5sVsk0L/'},
        {
            title: 'Santorini / Awe',
            url: 'https://www.instagram.com/p/CnOLW21O3ER/?img_index=1'},
        {
            title: 'Lines on a Leaf',
            url: 'https://genius.com/Dalmo-mendonca-lines-on-a-leaf-annotated'}
    ]
  },
  {
    title: 'Guided Meditations',
    description: 'Sit back, relax, and follow along to these grounding and awakening meditations.',
    link: '',
    category: 'Writing',
    icon: '../images/meditation-guidance.png',
    tags: ["writing", "language", "spiritual"],
    links: [
        {
            title: 'Christ Meditations',
            url: 'https://open.spotify.com/playlist/4RatDmNI8fRJ7JYFDMQ2VT?si=VVrpB9IpQtmW9npR68O1hA'},
        {
            title: 'I Am the Vine',
            url: 'https://www.youtube.com/watch?v=zhsOjSyUmnQ'},
        {
            title: 'Whole Body Mystical Awakening',
            url: 'https://youtu.be/mKLGxSlhpRk?si=_hKytFKAuI1nUgN6'},
        {
            title: 'WeSpace Meditation (WBMA)',
            url: 'https://youtu.be/LwhRPbwgt4A?si=SQGnUP6SPcBvdHeY'},
        {
            title: 'Receiving',
            url: 'https://open.spotify.com/episode/63oUgfocZpZA7VE5Vlgbya?si=468a7bd8bd1747e2'},
        {
            title: 'Romans 8',
            url: 'https://open.spotify.com/episode/2njDtLa7norVgKLCq67CIC?si=7cd1ca2fbbf34002'},
        {
            title: 'Sacred Breath',
            url: 'https://open.spotify.com/episode/3Dn0Zh74PKOtiVqXcSV0XM?si=cce08a89ba874681'},
        {
            title: 'Listening to the Symphony',
            url: 'https://open.spotify.com/episode/2pFPMFpLQEWZp6NaoBspAf?si=093e16636c0c47d6'},
        {
            title: 'Praying with the Mirror',
            url: 'https://open.spotify.com/episode/6kubQbuUF0tNEUxMeQymAu?si=654de2523a5e459b'}
    ]
  },
  {
    title: 'The Contemplative Heart',
    description: 'YouTube channel with contemplative music, guided meditations, and spiritual content.',
    link: 'https://www.youtube.com/@TheContemplativeHeart',
    category: 'Video',
    icon: 'images/contemplative-heart.jpg',
    tags: ["spiritual", "integral"],
    links: ''
  },
  {
    title: 'AI Art Galleries',
    description: 'Browse my curated collection of AI-generated art.',
    link: '',
    category: 'Art',
    icon: '../images/ai-art.png',
    tags: ["art", "ai"],
    story: `These galleries showcase a selection of AI-generated artworks I've created using various AI tools and techniques for the Integral Christian Network. Each piece explores different themes and styles, reflecting my journey into the intersection of art and technology.`,
    albums: [
            {
                title: 'Mystical Activism',
                url: '../images/AI Art/Mystical Activism',
                images: [
                    'Angelic Protection.png',
                    'Christ Is The Way.png',
                    'Circling Impressions.png',
                    'Circling with Love.png',
                    'Co-Creation.png',
                    'Collective Intention.png',
                    'Cosmic Energy.png',
                    'Dance the Cosmic Dance.png',
                    'Dawn of Awareness II.png',
                    'Dawn of Awareness.png',
                    'Embodied Unity.png',
                    'Enchanted Inner Forest.png',
                    'Father, The Hour Is Come.png',
                    'Flip the Tables.png',
                    'Global Consciousness.png',
                    'Global Culture Network.png',
                    'God Frequencies.png',
                    'He Mourns with Us.png',
                    'Heaven and Earth.png',
                    'Here, There & Everywhere.png',
                    'In and Through Me.png',
                    'Interconnection.png',
                    'Jesus Weeps.png',
                    'Let the Sun Shine In.png',
                    'Light in the Darkness.png',
                    'Lights of the World.png',
                    'Modern Monks.png',
                    'Mount of Transfiguration.png',
                    'Mystical Awakening.png',
                    'Mystical Prayer.png',
                    'On Earth As It Is In Heaven.png',
                    'Open Heavens.png',
                    'Pray for the City.png',
                    'Pray for the World.png',
                    'Prayer Energy Swirl.png',
                    'Prayer in Waves.png',
                    'Prayer is a Flame.png',
                    'Prayer Transforms the Universe.png',
                    'Prayer Vibes.png',
                    'Ripple Effect.png',
                    'Rooted Prayer.png',
                    'Sending Metta.png',
                    'Serene Meditation.png',
                    'Social Activist Jesus.png',
                    'Spiral of Peace.png',
                    'The Angelus.png',
                    'Transfiguration.png',
                    'Urban Monks.png',
                    'Visionary Christ.png',
                    'WeSpace Impressions.png'
                ]},
            {
                title: 'Divine Feminine',
                url: '../images/AI Art/Divine Feminine',
                images: [
                    'Action and Contemplation.png',
                    'Alabaster Devotion.png',
                    'Deborah.png',
                    'Desert Rose 2.png',
                    'Desert Rose.png',
                    'Dorcas and the Widows.png',
                    'Dreamweaver.png',
                    'Glossolalia.png',
                    'Hagar\'s Prayer.png',
                    'Like Miriam Danced.png',
                    'Mary and Martha.png',
                    'Patchwork Womanhood.png',
                    'Peace Anthem.png',
                    'Peace, Be Still.png',
                    'Phoebe, Priscilla, and Junia.png',
                    'Prophetess.png',
                    'Psalm 131.png',
                    'Sacred Womb.png',
                    'Sing Praise.png',
                    'Teacher Sophia.png',
                    'Women of Pentecost.png'
                ]},
            {
                title: 'Awakened Abilities',
                url: '../images/AI Art/Awakened Abilities',
                images: [
                    'A Network of Love.png',
                    'Building Together.png',
                    'Co-Laboring.png',
                    'Cosmic Scale.png',
                    'Courage.png',
                    'Creative Ability.png',
                    'Deep Listening.png',
                    'Direct Prayer.png',
                    'Fruits of the Spirit.png',
                    'Gatherer.png',
                    'Gifts and Fruits.png',
                    'Gifts from Heaven.png',
                    'Glossolalia in the City.png',
                    'Golden Shadow.png',
                    'Gratitude and Love.png',
                    'Helper 2.png',
                    'Helper.png',
                    'Intercession.png',
                    'Intuition.png',
                    'Leadership.png',
                    'Let Me Listen.png',
                    'Mystical Whispers.png',
                    'Open Hands.png',
                    'Overflowing Creativity.png',
                    'Quiet Contemplation.png',
                    'Resonant Heart.png',
                    'Resonant Prophecy.png',
                    'Sculpting the Future.png',
                    'Shaping the Future.png',
                    'Sophia.png',
                    'Soundwaves.png',
                    'Spiritual Potential.png',
                    'Stillness.png',
                    'The Jesus Way.png',
                    'To the Crazy Ones.png',
                    'Transmission.png',
                    'Visions of a Hopeful Future.png'
                ]}
        ]
  },
  {
    title: 'Epic Resume',
    description: 'Over the past 13+ years, I\'ve made a career out of solving complex technical problems and bringing visions to life in the healthcare IT space. ',
    link: 'https://hiredalmo.com/files/Dalmo%20Mendonca%20Resume%202026.pdf',
    category: 'Epic',
    icon: 'images/epic.jpg',
    tags: ["healthcare", "teaching"],
    story: `I started at Epic as an Ambulatory TS in the summer of 2012, at just 19 years old, with a college diploma in hand and a dream: to make an impact on patient care. The MyChart team eventually recruited me for my ability to learn quickly and lead effectively, and I fell in love with patient-facing technology. After a brief stint at a startup in NYC where I learned all about project and team management, I started my consulting career helping the large healthcare organizations tackle their biggest challenges.`
  },
];

export default projectsData;
